import { useRef } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import AppHeader from "./components/general/AppHeader/AppHeader";
import DataCollector from "./components/data-collector/DataCollector/DataCollector";
import { Toast } from "primereact/toast";
import DataWriter from "./components/data-writer/DataWriter/DataWriter";
import UrlInputForm from "./components/UrlInputForm";
import { ApiConfig, Pages } from "./axios/Config";
import UserService, { Permission } from "./service/UserService";
import Forbidden from "./components/Forbidden";
import { apisStore } from "./context/GlobalStates";
import JobRunner from "components/job-runner/JobRunner/JobRunner";
import DatasetsPage from "components/datasets/DatasetsPage";
import NotificationPopUp from "util/NotificationPopUp";
import "./App.css";

const setBaseUrlBasedOnRoute = (path: string) => {
  if (path === "/data_writer") {
    ApiConfig.setBaseUrl(Pages.DATA_WRITER);
  } else if (path === "/job_runner") {
    ApiConfig.setBaseUrl(Pages.JOB_RUNNER);
  } else {
    ApiConfig.setBaseUrl(Pages.DATA_COLLECTOR);
  }
};

const App = () => {
  const location = useLocation();
  setBaseUrlBasedOnRoute(location.pathname);

  const dataCollectorRef = useRef<DataCollector>(null);
  const dataWriterRef = useRef<DataWriter>(null);
  const jobRunnerRef = useRef<HTMLDivElement>(null);

  if (
    !UserService.isPermited(Permission.DATAHUB_USE) &&
    apisStore.getState().serviceId
  ) {
    return <Forbidden />;
  }
  return location.pathname !== "/" || apisStore.getState().serviceId ? (
    <div className="App">
      <Toast ref={NotificationPopUp.toast} />
      <div className="appHeader">
        <AppHeader
          dataCollectorRef={dataCollectorRef}
          dataWriterRef={dataWriterRef}
          jobRunnerRef={jobRunnerRef}
        />
      </div>
      <div className="appBody">
        <Routes>
          <Route
            path="/data_collector"
            element={<DataCollector ref={dataCollectorRef} />}
          />
          <Route
            path="/data_writer"
            element={<DataWriter ref={dataWriterRef} />}
          />
          <Route
            path="/job_runner"
            element={<JobRunner ref={jobRunnerRef} />}
          />
          <Route path="/datasets" element={<DatasetsPage />} />
          <Route
            path="/*"
            element={
              <h1 style={{ color: "white", textAlign: "center" }}>
                Page not found
              </h1>
            }
          />
          <Route path="/" element={<Navigate to="/data_collector" replace />} />
        </Routes>
      </div>
    </div>
  ) : (
    <UrlInputForm />
  );
};

export default App;
